var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.241,5.536H4.759a1.8,1.8,0,0,0-1.8,1.8v9.323a1.8,1.8,0,0,0,1.8,1.8H19.241a1.8,1.8,0,0,0,1.8-1.8V7.339A1.8,1.8,0,0,0,19.241,5.536Zm-6.468,6.958a1.107,1.107,0,0,1-1.55,0L5.578,7.036H18.386Zm-4.4-.673-3.91,3.91V8.039Zm1.078,1.043.734.71a2.6,2.6,0,0,0,3.639,0l.731-.711,4.1,4.1H5.346Zm6.179-1.05L19.542,8v7.727Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSmall);
export default __webpack_public_path__ + "static/media/mail_small.5fe1b049eef282e1680447ed4a171b37.svg";
export { ForwardRef as ReactComponent };